import { getRequestsStateKey, RequestError, RequestStatus } from 'acscp/store/requestsState';
import { AppState } from 'acscp/store';
import { getRequestType, RequestDescriptor } from 'acscp/api/requests';

export interface RequestStateProps {
    isLoading: boolean;
    requestError?: RequestError;
    success: boolean;
}

export function getRequestErrorFromState(state: AppState,
                                         requestDescriptor: RequestDescriptor<any>,
                                         callerId?: string): RequestStateProps {
    const requestType = getRequestType(requestDescriptor);

    const requestStatus = state.requests[getRequestsStateKey(requestType, callerId)] || {};

    return {
        isLoading: requestStatus.status === RequestStatus.InProgress,
        requestError: requestStatus.lastError,
        success: requestStatus.status === RequestStatus.Success,
    };
}
